import { api } from './api';

type Q = Record<string, string | number | boolean | null | undefined>;

export async function fileUrl(path: string, params?: Q) {
  const [bare, embedded] = path.split('?');
  const merged: Q = { ...Object.fromEntries(new URLSearchParams(embedded ?? '')), ...params };
  return api.fileUrl(bare, merged);
}

/** Web: opens the signed URL in a new tab (tab opened synchronously to dodge popup blockers). */
export async function openFile(path: string, params?: Q) {
  const win = window.open('about:blank', '_blank');
  const url = await fileUrl(path, params);
  if (win) win.location.href = url;
  else window.open(url, '_blank');
}

export async function openHtml(html: string) {
  const blob = new Blob([html], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
